(function($) {

	$( document ).ready(
		function() {
			initBruMaps();
		}
	);

	function initBruMaps() {
		var $allPageMaps   = $( '.bru-google-map' );
		let page_map_count = $allPageMaps.length;

		if (page_map_count > 0) {

			for (var i = 0; i < page_map_count; i++) {

				var currentMapCoordinates = {
					lat: parseFloat( $( $allPageMaps[i] ).data( 'lat' ) ),
					lng: parseFloat( $( $allPageMaps[i] ).data( 'lng' ) )
				};

				var interactive = $( $allPageMaps[i] ).data( 'interactive' );

				if ( ! interactive) {
					interactive = false;
				}

				var newMap = new google.maps.Map(
					$allPageMaps[i], {
						center: currentMapCoordinates,
						zoom: 14,
						zoomControlOptions: {
							position: google.maps.ControlPosition.TOP_LEFT
						},
						draggable: interactive,
						disableDefaultUI: ( ! interactive)
					}
				);

				var newMarker = new google.maps.Marker(
					{
						position: currentMapCoordinates,
						map: newMap,
						animation: google.maps.Animation.DROP,
					}
				);
			}
		}
	}

})( jQuery );
